import styled from 'styled-components'

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  background-color: #fff;
  border-radius: 0.7rem;
  width: 100%;
  padding: 1.2rem .8rem;

  .left{
    width: 30.3rem;
  }
`

export const HeaderDiv = styled.div`
    display: flex;
    justify-content: space-between;
`

export const HeaderText = styled.h3`
    font-family: 'Inter', sans-serif;
    font-size: clamp(0.9rem, calc(0.9rem + 0.2vw), 1.6rem);
    margin-top: 0;
    margin-bottom: 0;
`

export const PdfButtonDiv = styled.div`
    height: 2.35rem;
    border-radius: 0.95rem;
    width: 8.9rem;
    border: #0090D3 1px solid;
    display: flex;
    align-items: center;
`

export const PdfButtonImg = styled.img`
    width: 0.92rem;
    margin-left: 0.92rem;
`

export const PdfButtonText = styled.p`
    font-family: 'Inter', sans-serif;
    font-size: clamp(0.6rem, calc(0.6rem + 0.2vw), 1.5rem);
    font-weight: 700;
    color: #0090D3;
    margin-top: 0;
    margin-bottom: 0;
    margin-left: 0.44rem;
    cursor: pointer;
    user-select: none;
`

export const TextBox = styled.div`
    margin-top: 1.1rem;
`

export const TextRow = styled.div`
    margin-top: 0.32rem;
    display: flex;
`

export const SimpleText = styled.p`
    font-family: 'Inter', sans-serif;
    font-size: clamp(0.7rem, calc(0.7rem + 0.2vw), 1.6rem);
    margin-top: 0;
    margin-bottom: 0;
`

